module.exports = __webpack_public_path__ + "media/images/payments/ebay-19aa981178cc9d46cbc09c61c3a5582c.svg";